import { Card, Button, Input, TextField, Spinner } from '@heroui/react';
import { Link } from 'react-router-dom';
import { FieldLabel } from '@/components/molecules/FieldLabel';
import { useLoginPage } from './useLoginPage';

export function LoginPage() {
  const { login, setLogin, password, setPassword, loading, error, handleSubmit } = useLoginPage();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="bg-surface w-full max-w-sm">
        <div className="p-6">
          <h1 className="text-xl font-bold text-foreground mb-1">Visitor Check</h1>
          <p className="text-sm text-muted mb-6">Вход в панель администратора</p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <TextField variant="secondary" value={login} onChange={setLogin} isRequired>
              <FieldLabel>Логин</FieldLabel>
              <Input placeholder="admin_1" autoComplete="username" />
            </TextField>
            <TextField
              variant="secondary"
              value={password}
              onChange={setPassword}
              isRequired
              type="password"
            >
              <FieldLabel>Пароль</FieldLabel>
              <Input autoComplete="current-password" />
            </TextField>
            {error && <p className="text-sm text-danger">{error}</p>}
            <Button type="submit" size="md" isDisabled={loading}>
              {loading ? <Spinner size="sm" /> : 'Войти'}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-muted">
            Нет аккаунта?{' '}
            <Link to="/register" className="text-link hover:underline">
              Зарегистрироваться
            </Link>
          </p>
        </div>
      </Card>
    </div>
  );
}
